import useCurrency from "../../hook/useCurrency";

export const CurrencyText = ({ amount, sourceCurrency, className }) => {
  const { display, ready } = useCurrency();
  return ready ? <span className={className}>{display(amount, sourceCurrency)}</span> : <span></span>;
};
